'use client';

import { cn } from '@/utils';
import { ClassValue } from 'clsx';
import { redirect } from 'next/navigation';
import React, { useEffect } from 'react';

interface Props {
  exec?: boolean;
  className?: ClassValue;
  redirectAfter?: number;
  redirectTo?: string;
  redirectToPlaceholder?: string;
}

export function AutoRedirectBlock({ exec, className, redirectAfter = 5, redirectTo = '/', redirectToPlaceholder = 'home' }: Props) {
  const [timer, setTimer] = React.useState<number>(redirectAfter);

  useEffect(() => {
    if (exec) {
      setTimeout(() => {
        setTimer((prev) => prev - 1);
      }, 1000);
    }
  }, [exec, timer]);

  if (timer) {
    return <span className={cn(className)}>{`Redirecting to ${redirectToPlaceholder} after ${timer} seconds...`}</span>;
  } else {
    redirect(redirectTo);
  }
}
